import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=2ff819d8&scoped=true"
import script from "./Booking.vue?vue&type=script&lang=ts"
export * from "./Booking.vue?vue&type=script&lang=ts"
import style1 from "./Booking.vue?vue&type=style&index=1&id=2ff819d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff819d8",
  null
  
)

export default component.exports